import {useEffect,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useTune,request,readLocal} from './state.jsx';
import {personalPlaylistValid} from '../shared/playlists.js';
// Used only by Discover: navigating elsewhere unmounts all generation/retry timers.
export default function usePersonalPlaylist(){
  const {user,ready,discovery,library}=useTune(),location=useLocation();
  const [state,setState]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),[attempt,setAttempt]=useState(0);
  const recent=useRef(library.recent);recent.current=library.recent;
  // Polls while another request builds the mix; gives up after about 30 seconds so the listener can retry.
  const pendingPolls=useRef(0);
  const owner=user?.id||'guest';
  useEffect(()=>{
    if(!ready||!discovery?.ready)return;
    let cancelled=false,timer;setError('');
    function accept(playlist){
      pendingPolls.current=0;setState({owner,playlist});setBusy(false);
      if(!user)try{localStorage.setItem('tm:personal-playlist',JSON.stringify(playlist));}catch{setError('This browser could not save your mix.');}
      timer=setTimeout(()=>{if(!document.hidden)setAttempt(n=>n+1);},Math.max(1,Date.parse(playlist.expiresAt)-Date.now()+50));
    }
    const cached=!user?readLocal('tm:personal-playlist',null):null;
    if(personalPlaylistValid(cached))accept(cached);
    else{
      setBusy(true);
      request('/playlists/personal',{method:'POST',body:{recent:recent.current.map(s=>s.stationuuid).slice(0,100)}}).then(({playlist,pending})=>{
        if(cancelled)return;
        if(personalPlaylistValid(playlist))accept(playlist);
        else if(pending&&++pendingPolls.current<20){setState({owner,playlist:null});timer=setTimeout(()=>setAttempt(n=>n+1),1500);}
        else{pendingPolls.current=0;setState({owner,playlist:null});setBusy(false);if(pending)setError('Your mix is taking longer than usual.');}
      }).catch(e=>{if(!cancelled){pendingPolls.current=0;setError(e.message);setBusy(false);}});
    }
    function wake(){if(!document.hidden)setAttempt(n=>n+1);}
    document.addEventListener('visibilitychange',wake);
    return()=>{cancelled=true;clearTimeout(timer);document.removeEventListener('visibilitychange',wake);};
  },[ready,user?.id,discovery?.ready,location.pathname,attempt]);
  return {playlist:state?.owner===owner&&personalPlaylistValid(state.playlist)?state.playlist:null,busy,error,failed:!busy&&(Boolean(error)||(state?.owner===owner&&!state.playlist)),retry:()=>{pendingPolls.current=0;setAttempt(n=>n+1);}};
}
